/* Ic3y Mag theme behaviour: cursor, logo morph, globe, hover peek, format models, radio, cart. */
(function () {
  'use strict';
  var root = document.documentElement;
  var cfg = window.IC3Y_CONFIG || {};
  var raf = null, ticks = [];
  function onFrame(fn) { ticks.push(fn); }
  function loop() {
    for (var i = 0; i < ticks.length; i++) { try { ticks[i](); } catch (e) { /* never kill the loop */ } }
    raf = requestAnimationFrame(loop);
  }

  /* ---------- inverting circle cursor ---------- */
  var mx = -200, my = -200;
  function cursor() {
    if (!cfg.cursor || !matchMedia('(pointer:fine)').matches) return;
    document.body.classList.add('ic3y-cursor-on');
    var dot = document.createElement('div');
    dot.id = 'ic3y-cursor';
    dot.style.cssText = 'position:fixed;top:0;left:0;width:34px;height:34px;border-radius:999px;background:#fff;' +
      'mix-blend-mode:difference;pointer-events:none;z-index:2147483647;opacity:0;' +
      'transform:translate3d(-200px,-200px,0);transition:width .18s,height .18s,opacity .2s;will-change:transform';
    document.body.appendChild(dot);
    var cx = -200, cy = -200, big = false;
    addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY; dot.style.opacity = '1';
      var hot = !!(e.target && e.target.closest && e.target.closest('a,button,input,select,textarea,label,[role=button]'));
      if (hot !== big) { big = hot; dot.style.width = dot.style.height = hot ? '64px' : '34px'; }
    }, { passive: true });
    document.addEventListener('mouseleave', function () { dot.style.opacity = '0'; });
    onFrame(function () {
      cx += (mx - cx) * 0.22; cy += (my - cy) * 0.22;
      var r = parseFloat(dot.style.width) / 2;
      dot.style.transform = 'translate3d(' + (cx - r) + 'px,' + (cy - r) + 'px,0)';
    });
  }

  /* ---------- hover peek: square image that follows the pointer ---------- */
  var peek = null, peekOff = [34, -115];
  function initPeek() {
    if (!cfg.peek) return;
    peek = document.createElement('div');
    peek.id = 'ic3y-peek';
    peek.style.cssText = 'position:fixed;top:0;left:0;width:230px;height:230px;pointer-events:none;' +
      'z-index:2147483646;opacity:0;transform:translate3d(-500px,-500px,0) scale(.94);' +
      'transition:opacity .32s,transform .32s;overflow:hidden;background:#e4e4e4';
    document.body.appendChild(peek);
    onFrame(function () {
      if (peek.style.opacity !== '1') return;
      var px = Math.min(Math.max(mx + peekOff[0], 12), innerWidth - 242);
      var py = Math.min(Math.max(my + peekOff[1], 12), innerHeight - 242);
      peek.style.transform = 'translate3d(' + px + 'px,' + py + 'px,0) scale(1)';
    });
    var spread = [[420,-140],[-420,-60],[180,-280],[-260,-300],[340,60],[-500,-200],[560,-100],[-160,90]];
    var n = 0;
    document.querySelectorAll('[data-peek]').forEach(function (el) {
      var seat = spread[n++ % spread.length];
      el.addEventListener('mouseenter', function () {
        var img = el.getAttribute('data-peek-img');
        var label = el.getAttribute('data-peek') || '';
        peek.innerHTML = img
          ? '<img src="' + img + '" alt="" style="width:100%;height:100%;object-fit:cover">'
          : '<div class="ph" style="height:100%">' + label + '</div>';
        peekOff = [seat[0] + (Math.random() - 0.5) * 220, seat[1] + (Math.random() - 0.5) * 200];
        peek.style.opacity = '1';
      });
      el.addEventListener('mouseleave', function () { peek.style.opacity = '0'; });
    });
  }

  /* ---------- logo morph: real circle geometry, nearest-dot pairing, metaball merge ---------- */
  function morph() {
    var path = document.getElementById('ic3y-morph');
    var raw = window.IC3Y_LOGO_DOTS;
    if (!path || !raw) return;
    var VW = 1539, VH = 727, order = ['a', 'b', 'c', 'f', 'g'];
    var frames = order.filter(function (k) { return raw[k]; }).map(function (k) {
      var g = raw[k], xs = g.dots.map(function (d) { return d[0]; }), ys = g.dots.map(function (d) { return d[1]; });
      var dx = (VW - (Math.min.apply(null, xs) + Math.max.apply(null, xs))) / 2;
      var dy = (VH - (Math.min.apply(null, ys) + Math.max.apply(null, ys))) / 2;
      return g.dots.map(function (d) { return [d[0] + dx, d[1] + dy, d[2]]; });
    });
    if (!frames.length) return;
    var N = Math.max.apply(null, frames.map(function (f) { return f.length; }));
    var pad = frames.map(function (f) {
      var out = f.map(function (d) { return d.slice(); });
      while (out.length < N) { var s = f[out.length % f.length]; out.push([s[0], s[1], 0]); }
      return out;
    });
    for (var i = 0; i < pad.length; i++) {
      var cur = pad[i], nx = pad[(i + 1) % pad.length];
      var taken = new Array(N).fill(false), re = new Array(N);
      for (var s = 0; s < N; s++) {
        var best = -1, bd = Infinity;
        for (var t = 0; t < N; t++) {
          if (taken[t]) continue;
          var d2 = Math.pow(nx[t][0] - cur[s][0], 2) + Math.pow(nx[t][1] - cur[s][1], 2);
          if (d2 < bd) { bd = d2; best = t; }
        }
        taken[best] = true; re[s] = nx[best];
      }
      pad[(i + 1) % pad.length] = re;
    }
    var m = { i: 0, t: 0, hold: 0 }, HOLD = 150, TRANS = 118;
    var hero = document.getElementById('ic3y-hero');
    onFrame(function () {
      if (m.hold < HOLD) { m.hold++; m.t = 0; }
      else { m.t += 1 / TRANS; if (m.t >= 1) { m.t = 0; m.hold = 0; m.i = (m.i + 1) % pad.length; } }
      var from = pad[m.i], to = pad[(m.i + 1) % pad.length], d = '';
      for (var k = 0; k < N; k++) {
        var a = from[k], b = to[k];
        var lag = (a[0] / VW) * 0.32;
        var lt = Math.max(0, Math.min(1, (m.t - lag) / (1 - 0.32)));
        var e = lt < 0.5 ? 4 * lt * lt * lt : 1 - Math.pow(-2 * lt + 2, 3) / 2;
        var x = a[0] + (b[0] - a[0]) * e, y = a[1] + (b[1] - a[1]) * e, r = a[2] + (b[2] - a[2]) * e;
        if (r < 0.4) continue;
        d += 'M' + (x - r).toFixed(1) + ' ' + y.toFixed(1) + 'a' + r.toFixed(1) + ' ' + r.toFixed(1) +
          ' 0 1 0 ' + (r * 2).toFixed(1) + ' 0a' + r.toFixed(1) + ' ' + r.toFixed(1) + ' 0 1 0 ' + (-r * 2).toFixed(1) + ' 0Z';
      }
      path.setAttribute('d', d);
      if (hero) hero.style.opacity = Math.max(0.05, Math.min(1, 1 - (scrollY || 0) / (innerHeight * 0.5)));
    });
  }

  /* ---------- interactive dotted planet ---------- */
  function planet() {
    var svg = document.getElementById('ic3y-globe');
    var data = window.IC3Y_GLOBE;
    if (!svg || !data) return;
    var dots = svg.querySelector('#ic3y-globe-dots');
    var disc = svg.querySelector('#ic3y-globe-disc');
    var g = { yaw: -60, pitch: -18, zoom: 1.32, tYaw: null, tPitch: 0, drag: null, spin: true, aimYaw: undefined, aimPitch: 0 };
    var spinBtn = document.getElementById('ic3y-spin');
    if (spinBtn) spinBtn.addEventListener('click', function () {
      g.spin = !g.spin;
      spinBtn.textContent = g.spin ? 'spin: on' : 'spin: off';
    });
    svg.addEventListener('pointerdown', function (e) {
      g.drag = { x: e.clientX, y: e.clientY, yaw: g.yaw, pitch: g.pitch };
      g.tYaw = null;
      if (svg.setPointerCapture) svg.setPointerCapture(e.pointerId);
    });
    svg.addEventListener('pointermove', function (e) {
      if (!g.drag) return;
      g.aimYaw = g.drag.yaw + (e.clientX - g.drag.x) * 0.22;
      g.aimPitch = Math.max(-78, Math.min(78, g.drag.pitch + (e.clientY - g.drag.y) * 0.2));
    });
    function up() { g.drag = null; }
    svg.addEventListener('pointerup', up);
    svg.addEventListener('pointerleave', up);

    window.IC3Y_lookAt = function (city) {
      var c = data.cities[city];
      if (!c) return;
      g.tYaw = -c[0]; g.tPitch = c[1]; g.spin = false;
      if (spinBtn) spinBtn.textContent = 'spin: off';
    };

    var R = 100, rad = Math.PI / 180;
    onFrame(function () {
      if (g.tYaw !== null) {
        var d = ((g.tYaw - g.yaw + 540) % 360) - 180;
        g.yaw += d * 0.055;
        g.pitch += (g.tPitch - g.pitch) * 0.055;
        if (Math.abs(d) < 0.25) { g.yaw = g.tYaw; g.pitch = g.tPitch; g.tYaw = null; }
      } else if (g.drag && g.aimYaw !== undefined) {
        g.yaw += (g.aimYaw - g.yaw) * 0.16;
        g.pitch += (g.aimPitch - g.pitch) * 0.16;
      } else if (g.spin) { g.yaw += 0.028; }

      var half = 150 / g.zoom;
      svg.setAttribute('viewBox', (-half).toFixed(1) + ' ' + (-half).toFixed(1) + ' ' + (half * 2).toFixed(1) + ' ' + (half * 2).toFixed(1));
      var cp = Math.cos(g.pitch * rad), sp = Math.sin(g.pitch * rad);
      function project(lon, lat) {
        var la = (lon + g.yaw) * rad, ph = lat * rad, cf = Math.cos(ph);
        var x0 = cf * Math.sin(la), y0 = Math.sin(ph), z0 = cf * Math.cos(la);
        var y1 = y0 * cp - z0 * sp, z1 = y0 * sp + z0 * cp;
        return [R * x0, -R * y1, z1];
      }
      var d2 = '';
      for (var i = 0; i < data.points.length; i++) {
        var p = project(data.points[i][0], data.points[i][1]);
        if (p[2] > 0.02) d2 += 'M' + p[0].toFixed(1) + ' ' + p[1].toFixed(1) + 'h0.01';
      }
      if (dots) {
        dots.setAttribute('d', d2);
        dots.setAttribute('stroke-width', (2.9 / Math.sqrt(g.zoom)).toFixed(2));
      }
      if (disc) disc.setAttribute('r', R.toFixed(1));
      svg.querySelectorAll('[data-city]').forEach(function (el) {
        var c = data.cities[el.getAttribute('data-city')];
        if (!c) return;
        var p = project(c[0], c[1]);
        var on = p[2] > 0.05;
        el.style.opacity = on ? '1' : '0';
        el.style.pointerEvents = on ? 'auto' : 'none';
        el.setAttribute('transform', 'translate(' + p[0].toFixed(1) + ',' + p[1].toFixed(1) + ')');
      });
    });
  }

  /* ---------- stockist city cards ---------- */
  function cities() {
    var cards = document.querySelectorAll('[data-city-card]');
    if (!cards.length) return;
    function show(city) {
      cards.forEach(function (c) { c.hidden = c.getAttribute('data-city-card') !== city; });
      document.querySelectorAll('[data-city-pill]').forEach(function (p) {
        p.classList.toggle('is-on', p.getAttribute('data-city-pill') === city);
      });
      if (window.IC3Y_lookAt) window.IC3Y_lookAt(city);
    }
    document.querySelectorAll('[data-city-pill]').forEach(function (p) {
      p.addEventListener('click', function () { show(p.getAttribute('data-city-pill')); });
    });
    document.querySelectorAll('[data-city]').forEach(function (pin) {
      pin.addEventListener('click', function () { show(pin.getAttribute('data-city')); });
    });
    document.querySelectorAll('[data-city-close]').forEach(function (b) {
      b.addEventListener('click', function () { cards.forEach(function (c) { c.hidden = true; }); 
        document.querySelectorAll('[data-city-pill]').forEach(function (p) { p.classList.remove('is-on'); }); });
    });
  }

  /* ---------- events: format filter + accordion ---------- */
  function events() {
    var rows = document.querySelectorAll('[data-event]');
    if (!rows.length) return;
    var note = document.getElementById('ic3y-format-note');
    var active = null;
    document.querySelectorAll('[data-format]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = btn.getAttribute('data-format');
        active = active === f ? null : f;
        document.querySelectorAll('[data-format]').forEach(function (b) {
          b.classList.toggle('is-on', b.getAttribute('data-format') === active);
        });
        rows.forEach(function (r) {
          r.hidden = !!active && r.getAttribute('data-event-format') !== active;
        });
        if (note) note.textContent = active
          ? 'showing ' + (active === 'hifi' ? 'listening room' : 'obscura') + ' sessions — tap again for all'
          : 'tap a format to filter the sessions below';
      });
    });
    rows.forEach(function (row) {
      var head = row.querySelector('[data-event-toggle]');
      var body = row.querySelector('[data-event-detail]');
      var sign = row.querySelector('[data-event-sign]');
      if (!head || !body) return;
      head.addEventListener('click', function () {
        var open = !body.hidden;
        body.hidden = open;
        row.classList.toggle('is-open', !open);
        if (sign) sign.textContent = open ? '+' : '−';
      });
    });
  }

  /* ---------- format hover models: software 3D + pixel scan reveal ---------- */
  function models() {
    var host = document.getElementById('ic3y-model');
    var cv = document.getElementById('ic3y-model-canvas');
    if (!host || !cv) return;
    var built = null, kind = null, phase = 0, scan = 0, src = null, scratch = null, zbuf = null, rgba = null;

    function build() {
      if (built) return built;
      var tris = [];
      function push(a, b, c, col) { tris.push([a, b, c, col]); }
      function xf(p, s, t) { return [p[0] * s[0] + t[0], p[1] * s[1] + t[1], p[2] * s[2] + t[2]]; }
      function box(s, t, col) {
        var v = [[-1,-1,-1],[1,-1,-1],[1,1,-1],[-1,1,-1],[-1,-1,1],[1,-1,1],[1,1,1],[-1,1,1]]
          .map(function (p) { return xf(p, [s[0]/2, s[1]/2, s[2]/2], t); });
        [[0,3,2,1],[4,5,6,7],[0,1,5,4],[1,2,6,5],[2,3,7,6],[3,0,4,7]].forEach(function (q) {
          push(v[q[0]], v[q[1]], v[q[2]], col); push(v[q[0]], v[q[2]], v[q[3]], col);
        });
      }
      function disc(r, t, col, seg) {
        seg = seg || 36;
        for (var j = 0; j < seg; j++) {
          var a0 = 2 * Math.PI * j / seg, a1 = 2 * Math.PI * (j + 1) / seg;
          push(t, [t[0] + Math.cos(a0) * r, t[1] + Math.sin(a0) * r, t[2]],
                  [t[0] + Math.cos(a1) * r, t[1] + Math.sin(a1) * r, t[2]], col);
        }
      }
      function tube(r0, r1, h, t, col, seg) {
        seg = seg || 20;
        for (var j = 0; j < seg; j++) {
          var a0 = 2 * Math.PI * j / seg, a1 = 2 * Math.PI * (j + 1) / seg;
          var A = [t[0] + Math.cos(a0) * r0, t[1] - h / 2, t[2] + Math.sin(a0) * r0];
          var B = [t[0] + Math.cos(a1) * r0, t[1] - h / 2, t[2] + Math.sin(a1) * r0];
          var C = [t[0] + Math.cos(a1) * r1, t[1] + h / 2, t[2] + Math.sin(a1) * r1];
          var D = [t[0] + Math.cos(a0) * r1, t[1] + h / 2, t[2] + Math.sin(a0) * r1];
          push(A, B, C, col); push(A, C, D, col);
          push([t[0], t[1] + h / 2, t[2]], D, C, col);
          push([t[0], t[1] - h / 2, t[2]], B, A, col);
        }
      }
      // Listening Room: wood cabinet, aluminium baffle, two drivers, horn slot
      tris.length = 0;
      box([1.94, 3.5, 1.62], [0, 0, 0], [104, 66, 42]);
      box([1.86, 3.44, 0.1], [0, 0, 0.83], [148, 148, 152]);
      [[0.84, 0.68], [-0.94, 0.72]].forEach(function (d) {
        disc(d[1], [0, d[0], 0.89], [44, 44, 48]);
        disc(d[1] * 0.93, [0, d[0], 0.9], [23, 23, 25]);
        disc(d[1] * 0.34, [0, d[0], 0.91], [33, 33, 36]);
        disc(d[1] * 0.12, [0, d[0], 0.92], [18, 18, 20]);
      });
      box([1.24, 0.52, 0.06], [0, -0.04, 0.86], [126, 126, 130]);
      box([1.1, 0.4, 0.16], [0, -0.04, 0.8], [16, 16, 18]);
      [-0.79, 0.79].forEach(function (bx) {
        [1.62, 0.16, -0.26, -1.62].forEach(function (by) { disc(0.11, [bx, by, 0.89], [30, 30, 33], 16); });
      });
      [-0.7, 0.7].forEach(function (sx) {
        [-0.55, 0.55].forEach(function (sz) { tube(0.11, 0.11, 0.16, [sx, -1.82, sz], [40, 40, 44], 12); });
      });
      var speaker = tris.slice();

      // Obscura: aviator sleep mask — satin pillow, nose notch, elastic tabs
      tris.length = 0;
      var shell = [34, 34, 38], edge = [18, 18, 22];
      function prof(u) { return Math.pow(Math.max(0, 1 - u * u), 0.3); }
      function yTop(u) { return 0.84 * prof(u); }
      function yBot(u) { return -0.82 * prof(u) + 0.9 * Math.exp(-Math.pow(u * 4.6, 2)); }
      function thick(u) { return 0.34 * Math.pow(Math.max(0.001, prof(u)), 0.42); }
      function surf(u, v, sign) {
        var t = yBot(u) + v * (yTop(u) - yBot(u));
        return [u * 1.84, t, sign * thick(u) * Math.sin(Math.PI * v)];
      }
      var US = 46, VS = 16;
      for (var i2 = 0; i2 < US; i2++) for (var j2 = 0; j2 < VS; j2++) {
        var u0 = -1 + 2 * i2 / US, u1 = -1 + 2 * (i2 + 1) / US, v0 = j2 / VS, v1 = (j2 + 1) / VS;
        [1, -1].forEach(function (s) {
          var A = surf(u0, v0, s), B = surf(u1, v0, s), C = surf(u1, v1, s), D = surf(u0, v1, s);
          if (s > 0) { push(A, B, C, shell); push(A, C, D, shell); }
          else { push(C, B, A, shell); push(D, C, A, shell); }
        });
      }
      for (var i3 = 0; i3 < US; i3++) {
        var w0 = -1 + 2 * i3 / US, w1 = -1 + 2 * (i3 + 1) / US;
        [0, 1].forEach(function (v) {
          var A = surf(w0, v, 1), B = surf(w1, v, 1), C = surf(w1, v, -1), D = surf(w0, v, -1);
          push(A, B, C, edge); push(A, C, D, edge); push(C, B, A, edge); push(D, C, A, edge);
        });
      }
      [-1, 1].forEach(function (sx) {
        box([0.5, 0.34, 0.09], [sx * 1.98, 0.06, 0], [30, 30, 34]);
        box([0.42, 0.28, 0.07], [sx * 2.32, 0.06, -0.06], [24, 24, 28]);
      });
      var mask = tris.slice();
      built = { hifi: speaker, mask: mask };
      return built;
    }

    document.querySelectorAll('[data-model]').forEach(function (btn) {
      btn.addEventListener('mouseenter', function () {
        build();
        kind = btn.getAttribute('data-model');
        phase = 0; scan = 0;
        host.style.opacity = '1';
      });
      btn.addEventListener('mouseleave', function () { host.style.opacity = '0'; kind = null; });
    });

    var S = 300, RW = 600;
    onFrame(function () {
      if (!kind || !built) return;
      if (!src) { src = document.createElement('canvas'); src.width = RW; src.height = RW; }
      if (!zbuf) { zbuf = new Float32Array(RW * RW); rgba = new Uint8ClampedArray(RW * RW * 4); }
      var mesh = built[kind];
      phase += 0.0075;
      var osc = Math.sin(phase) * 0.5;
      var yaw = osc * (kind === 'mask' ? 0.55 : 1) - (kind === 'mask' ? 0.12 : 0.34);
      var pitch = kind === 'mask' ? -0.1 : -0.16;
      var zoom = kind === 'mask' ? 0.98 : 1;
      var cy = Math.cos(yaw), sy = Math.sin(yaw), cp = Math.cos(pitch), sp = Math.sin(pitch);
      var camZ = 7.6, fov = 330 * zoom, half = RW / 2, L = [0.52, 0.66, 0.54];
      zbuf.fill(Infinity); rgba.fill(0);
      for (var t = 0; t < mesh.length; t++) {
        var tri = mesh[t], col = tri[3];
        function tp(p) {
          var x = p[0] * cy + p[2] * sy, z = -p[0] * sy + p[2] * cy;
          return [x, p[1] * cp - z * sp, p[1] * sp + z * cp];
        }
        var A = tp(tri[0]), B = tp(tri[1]), C = tp(tri[2]);
        var u = [B[0]-A[0], B[1]-A[1], B[2]-A[2]], v = [C[0]-A[0], C[1]-A[1], C[2]-A[2]];
        var n = [u[1]*v[2]-u[2]*v[1], u[2]*v[0]-u[0]*v[2], u[0]*v[1]-u[1]*v[0]];
        var nl = Math.hypot(n[0], n[1], n[2]) || 1;
        n = [n[0]/nl, n[1]/nl, n[2]/nl];
        if (n[2] <= 0.015) continue;
        var lam = Math.max(0, n[0]*L[0] + n[1]*L[1] + n[2]*L[2]);
        var hn = [L[0], L[1], L[2] + 1], hl = Math.hypot(hn[0], hn[1], hn[2]) || 1;
        var spec = Math.pow(Math.max(0, (n[0]*hn[0] + n[1]*hn[1] + n[2]*hn[2]) / hl), 26) * 0.42;
        var sh = 0.36 + 0.62 * lam + spec;
        var cr = Math.min(255, col[0]*sh), cg = Math.min(255, col[1]*sh), cb = Math.min(255, col[2]*sh);
        function pr(P) { var d = camZ - P[2], k = (fov * 2) / Math.max(0.6, d); return [half + P[0]*k, half - P[1]*k, d]; }
        var p0 = pr(A), p1 = pr(B), p2 = pr(C);
        var minX = Math.max(0, Math.floor(Math.min(p0[0], p1[0], p2[0])));
        var maxX = Math.min(RW - 1, Math.ceil(Math.max(p0[0], p1[0], p2[0])));
        var minY = Math.max(0, Math.floor(Math.min(p0[1], p1[1], p2[1])));
        var maxY = Math.min(RW - 1, Math.ceil(Math.max(p0[1], p1[1], p2[1])));
        if (maxX < minX || maxY < minY) continue;
        var area = (p1[0]-p0[0])*(p2[1]-p0[1]) - (p2[0]-p0[0])*(p1[1]-p0[1]);
        if (Math.abs(area) < 1e-7) continue;
        var inv = 1 / area;
        for (var py = minY; py <= maxY; py++) for (var px = minX; px <= maxX; px++) {
          var x2 = px + 0.5, y2 = py + 0.5;
          var w0 = ((p1[0]-x2)*(p2[1]-y2) - (p2[0]-x2)*(p1[1]-y2)) * inv;
          var w1 = ((p2[0]-x2)*(p0[1]-y2) - (p0[0]-x2)*(p2[1]-y2)) * inv;
          var w2 = 1 - w0 - w1;
          if (w0 < -1e-4 || w1 < -1e-4 || w2 < -1e-4) continue;
          var depth = w0 * p0[2] + w1 * p1[2] + w2 * p2[2];
          var idx = py * RW + px;
          if (depth >= zbuf[idx]) continue;
          zbuf[idx] = depth;
          var o = idx * 4;
          rgba[o] = cr; rgba[o+1] = cg; rgba[o+2] = cb; rgba[o+3] = 255;
        }
      }
      src.getContext('2d').putImageData(new ImageData(rgba, RW, RW), 0, 0);

      var oc = cv.getContext('2d');
      oc.clearRect(0, 0, S, S);
      if (scan >= 1.2) { oc.imageSmoothingEnabled = true; oc.drawImage(src, 0, 0, S, S); return; }
      scan += 0.019;
      oc.imageSmoothingEnabled = false;
      if (!scratch) { scratch = document.createElement('canvas'); scratch.width = S; scratch.height = S; }
      var tc = scratch.getContext('2d');
      tc.imageSmoothingEnabled = true;
      var bands = 25, bandH = S / bands;
      for (var b = 0; b < bands; b++) {
        var local = Math.max(0, Math.min(1, (scan - b / bands) * 2.6));
        var pxs = Math.max(1, Math.round(22 * Math.pow(1 - local, 2)));
        var y = b * bandH;
        if (pxs <= 1) {
          oc.imageSmoothingEnabled = true;
          oc.drawImage(src, 0, y * 2, S * 2, bandH * 2, 0, y, S, bandH);
          oc.imageSmoothingEnabled = false;
          continue;
        }
        var w = Math.max(1, Math.round(S / pxs)), h = Math.max(1, Math.round(bandH / pxs));
        tc.clearRect(0, 0, w, h);
        tc.drawImage(src, 0, y * 2, S * 2, bandH * 2, 0, 0, w, h);
        oc.drawImage(scratch, 0, 0, w, h, 0, y, S, bandH);
      }
      if (scan < 1) {
        oc.fillStyle = cfg.accent || 'rgba(247,239,74,0.9)';
        oc.fillRect(0, scan * S - 1.5, S, 3);
      }
    });
  }

  /* ---------- SoundCloud radio bar ---------- */
  function radio() {
    var bar = document.getElementById('ic3y-radio');
    if (!bar || !cfg.radioUrl) return;
    var hostEl = bar.querySelector('.radio__host');
    var fill = bar.querySelector('.radio__fill');
    var icon = bar.querySelector('.radio__icon');
    var title = bar.querySelector('.radio__title');
    var btn = bar.querySelector('.radio__btn');
    var frame = document.createElement('iframe');
    frame.width = '1'; frame.height = '1'; frame.setAttribute('frameborder', 'no'); frame.allow = 'autoplay';
    frame.src = 'https://w.soundcloud.com/player/?url=' + encodeURIComponent(cfg.radioUrl) +
      '&auto_play=false&hide_related=true&show_comments=false&visual=false';
    hostEl.appendChild(frame);
    var tries = 0;
    var wait = setInterval(function () {
      if (window.SC && window.SC.Widget) { clearInterval(wait); wire(); }
      else if (++tries > 60) clearInterval(wait);
    }, 200);
    function wire() {
      var w = window.SC.Widget(frame), E = window.SC.Widget.Events;
      w.bind(E.READY, function () {
        w.getCurrentSound(function (s) { if (s && s.title && title) title.textContent = s.title; });
      });
      w.bind(E.PLAY, function () {
        if (icon) icon.textContent = '❚❚';
        w.getCurrentSound(function (s) { if (s && s.title && title) title.textContent = s.title; });
      });
      w.bind(E.PAUSE, function () { if (icon) icon.textContent = '▶'; });
      w.bind(E.FINISH, function () { if (icon) icon.textContent = '▶'; });
      w.bind(E.PLAY_PROGRESS, function (e) {
        w.getDuration(function (d) { if (fill && d) fill.style.width = ((e.currentPosition / d) * 100).toFixed(1) + '%'; });
      });
      if (btn) btn.addEventListener('click', function () { w.toggle(); });
    }
  }

  /* ---------- cart: Shopify AJAX + section rendering ---------- */
  function toast(msg) {
    var el = document.createElement('div');
    el.className = 'toast';
    el.textContent = msg;
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 2200);
  }
  function refreshDrawer(open) {
    return fetch(root.dataset.rootUrl.replace(/\/$/, '') + '/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var host = document.getElementById('ic3y-drawer-host');
        if (!host || !j['cart-drawer']) return;
        host.innerHTML = j['cart-drawer'];
        bindDrawer();
        if (open) openDrawer();
      });
  }
  function openDrawer() {
    var d = document.querySelector('.drawer');
    if (d) { d.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  }
  function closeDrawer() {
    var d = document.querySelector('.drawer');
    if (d) { d.classList.remove('is-open'); document.body.style.overflow = ''; }
  }
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }
  function change(line, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (c) {
      setCount(c.item_count);
      return refreshDrawer(false);
    });
  }
  function bindDrawer() {
    document.querySelectorAll('[data-drawer-close]').forEach(function (b) {
      b.addEventListener('click', closeDrawer);
    });
    document.querySelectorAll('[data-line-change]').forEach(function (b) {
      b.addEventListener('click', function () {
        change(+b.getAttribute('data-line'), +b.getAttribute('data-line-change'));
      });
    });
  }
  function cart() {
    document.querySelectorAll('[data-cart-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); refreshDrawer(true); });
    });
    document.addEventListener('click', function (e) {
      if (e.target.classList && e.target.classList.contains('drawer__veil')) closeDrawer();
    });
    addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    bindDrawer();

    document.querySelectorAll('form.ic3y-add').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type=submit]');
        var label = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'adding…'; }
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
          .then(function (r) { return r.json(); })
          .then(function (item) {
            toast('added — ' + (item.product_title || '').toLowerCase());
            return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); });
          })
          .then(function () { return refreshDrawer(true); })
          .catch(function () { toast('could not add that'); })
          .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
      });
    });
  }

  /* ---------- collection + blog filter pills ---------- */
  function filters() {
    document.querySelectorAll('[data-filter-group]').forEach(function (group) {
      var items = document.querySelectorAll('[data-filter-item]');
      group.querySelectorAll('[data-filter]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          var f = pill.getAttribute('data-filter');
          group.querySelectorAll('[data-filter]').forEach(function (p) { p.classList.toggle('is-on', p === pill); });
          var shown = 0;
          items.forEach(function (it) {
            var tags = (it.getAttribute('data-filter-item') || '').toLowerCase();
            var on = f === 'all' || tags.indexOf(f.toLowerCase()) !== -1;
            it.hidden = !on;
            if (on) shown++;
          });
          var count = document.getElementById('ic3y-filter-count');
          if (count) count.textContent = shown + (shown === 1 ? ' item' : ' items');
        });
      });
    });
  }

  function boot() {
    cursor(); initPeek(); morph(); planet(); cities(); events(); models(); radio(); cart(); filters();
    if (ticks.length) loop();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
